"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6232],{

/***/ 86232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": function() { return /* binding */ CheckboxInput; },
/* harmony export */   "Kx": function() { return /* binding */ TextArea; },
/* harmony export */   "WU": function() { return /* binding */ PasswordInput; },
/* harmony export */   "Wr": function() { return /* binding */ DateInput; },
/* harmony export */   "Y2": function() { return /* binding */ NumberInput; },
/* harmony export */   "Yw": function() { return /* binding */ MultipleSelectInput; },
/* harmony export */   "cI": function() { return /* binding */ getInputClasses; },
/* harmony export */   "lq": function() { return /* binding */ SelectInput; },
/* harmony export */   "oi": function() { return /* binding */ TextInput; },
/* harmony export */   "sZ": function() { return /* binding */ CheckRadioInput; },
/* harmony export */   "xI": function() { return /* binding */ UploadFileButton; }
/* harmony export */ });
/* unused harmony export MultipleSelectInputV2 */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35079);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74685);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13342);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68163);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71738);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77481);
/* harmony import */ var lib_classNames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44882);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_imask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79214);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57333);
/* harmony import */ var wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17481);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22692);
/* eslint-disable react/display-name */ 












var NumberInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var error = _param.error, id = _param.id, label = _param.label, rightIcon = _param.rightIcon, _className = _param.className, className = _className === void 0 ? "" : _className, disabled = _param.disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "error",
        "id",
        "label",
        "rightIcon",
        "className",
        "disabled"
    ]);
    var classes = getInputClasses({
        error: error,
        disabled: disabled
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputController, {
        id: id,
        label: label,
        error: error,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    id: id,
                    getInputRef: ref,
                    className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(classes, className),
                    disabled: disabled
                }, props)),
                rightIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute flex justify-center items-center text-gray-500 right-3 inset-y-0",
                    children: rightIcon
                })
            ]
        })
    });
});
var SelectInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, // eslint-disable-next-line no-unused-vars
ref) {
    var error = _param.error, id = _param.id, label = _param.label, value = _param.value, onChange = _param.onChange, _options = _param.options, options = _options === void 0 ? [] : _options, placeholder = _param.placeholder, disabled = _param.disabled, emptyState = _param.emptyState, className = _param.className, buttonClasses = _param.buttonClasses, name = _param.name, _isClearable = _param.isClearable, isClearable = _isClearable === void 0 ? false : _isClearable, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "error",
        "id",
        "label",
        "value",
        "onChange",
        "options",
        "placeholder",
        "disabled",
        "emptyState",
        "className",
        "buttonClasses",
        "name",
        "isClearable"
    ]);
    var classes = getSelectClasses({
        error: error,
        disabled: disabled
    });
    var selected = options.find(function(c) {
        return c.value === value;
    }) || null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputController, {
        id: id,
        label: label,
        error: error,
        name: name,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox */ .R, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            value: selected,
            onChange: function(val) {
                return onChange(val.value);
            },
            disabled: disabled
        }, props), {
            children: function(param) {
                var open = param.open;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)("mt-1 relative", className),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox.Button */ .R.Button, {
                            className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(classes, buttonClasses),
                            ref: ref,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)("block truncate", (selected === null || selected === void 0 ? void 0 : selected.label) ? "text-black" : error ? "text-red-300" : "text-gray-500"),
                                    children: [
                                        (selected === null || selected === void 0 ? void 0 : selected.decorator) || "",
                                        (selected === null || selected === void 0 ? void 0 : selected.label) || placeholder
                                    ]
                                }),
                                !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "absolute inset-y-0 right-0 flex items-center pr-2 cursor-default",
                                    children: open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        className: "h-7 w-7 text-gray-400",
                                        "aria-hidden": "true"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        className: "h-7 w-7 text-gray-400",
                                        "aria-hidden": "true"
                                    })
                                }),
                                isClearable && !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    role: "button",
                                    tabIndex: 0,
                                    onClick: function(e) {
                                        e.preventDefault();
                                        onChange("");
                                    },
                                    onKeyPress: function(e) {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            onChange("");
                                        }
                                    },
                                    title: "Clear filter",
                                    className: "absolute bottom-2.5 text-gray-400 cursor-pointer hover:text-gray-500 right-9",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        height: 16,
                                        width: 16
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox.Options */ .R.Options, {
                            className: "absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                            children: [
                                emptyState && !options.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox.Option */ .R.Option, {
                                    disabled: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-1 items-center pl-4 pt-3 pb-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)("block truncate font-normal"),
                                            children: emptyState
                                        })
                                    })
                                }),
                                options.map(function(option) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox.Option */ .R.Option, {
                                        className: function(param) {
                                            var active = param.active;
                                            return (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(active ? "text-white bg-indigo-600" : "text-gray-900", "cursor-default select-none relative p-3");
                                        },
                                        value: option,
                                        children: function(param) {
                                            var selected = param.selected;
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-1 items-center gap-0.5",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                        children: option.label
                                                    }),
                                                    option === null || option === void 0 ? void 0 : option.rightElement
                                                ]
                                            });
                                        }
                                    }, option.value);
                                })
                            ]
                        })
                    ]
                });
            }
        }))
    });
});
var MultipleSelectInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, // eslint-disable-next-line no-unused-vars
ref) {
    var id = _param.id, label = _param.label, error = _param.error, placeholder = _param.placeholder, disabled = _param.disabled, emptyState = _param.emptyState, _value = _param.value, value = _value === void 0 ? [] : _value, onChange = _param.onChange, options = _param.options, variant = _param.variant, name = _param.name, _truncate = _param.truncate, truncate = _truncate === void 0 ? false : _truncate, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "id",
        "label",
        "error",
        "placeholder",
        "disabled",
        "emptyState",
        "value",
        "onChange",
        "options",
        "variant",
        "name",
        "truncate"
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value), selecteds = ref1[0], setSelecteds = ref1[1];
    var classes = getSelectClasses({
        error: error,
        disabled: disabled,
        variant: variant
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputController, {
        id: id,
        label: label,
        error: error,
        name: name,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox */ .R, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            defaultValue: selecteds,
            disabled: disabled,
            name: name
        }, rest), {
            children: function(param) {
                var open = param.open;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-1 relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox.Button */ .R.Button, {
                                className: classes,
                                title: selecteds.map(function(item) {
                                    return item.label;
                                }).join(", "),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(selecteds.length > 0 ? "text-black ".concat(truncate ? "truncate inline-block w-[calc(80%)]" : "") : error ? "text-red-300" : variant === "invisible" ? "text-black" : "text-gray-500"),
                                        children: selecteds.length > 0 ? selecteds.map(function(param) {
                                            var label = param.label;
                                            return label;
                                        }).join(", ") : placeholder
                                    }),
                                    !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "absolute inset-y-0 right-0 flex items-center pr-2 cursor-default",
                                        children: open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            className: "h-7 w-7 text-gray-400",
                                            "aria-hidden": "true"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            className: "h-7 w-7 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox.Options */ .R.Options, {
                                className: "absolute z-20 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                                children: [
                                    emptyState && !options.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Listbox.Option */ .R.Option, {
                                        disabled: true,
                                        children: function() {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex flex-1 items-center pl-4 pt-3 pb-3",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)("block truncate font-normal"),
                                                    children: emptyState
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "overflow-auto max-h-36",
                                        children: options.map(function(option) {
                                            var handleChange = function() {
                                                if (selecteds.find(function(item) {
                                                    return item.value === option.value;
                                                })) {
                                                    onChange && onChange(selecteds.filter(function(item) {
                                                        return item.value !== option.value;
                                                    }));
                                                    setSelecteds(selecteds.filter(function(item) {
                                                        return item.value !== option.value;
                                                    }));
                                                } else {
                                                    onChange && onChange((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(selecteds).concat([
                                                        option
                                                    ]));
                                                    setSelecteds((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(selecteds).concat([
                                                        option
                                                    ]));
                                                }
                                            };
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    option.tooltip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "absolute break-normal h-11 text-xs bg-gray-700 text-white opacity-0 hover:opacity-100 p-2 z-50",
                                                        children: option.tooltip
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)("cursor-default select-none relative p-3 text-gray-900 ", !disabled && "hover:bg-indigo-600 hover:text-white", (disabled || option.disabled) && "opacity-50 hover:bg-white pointer-events-none"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "flex flex-1 w-full items-center",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CheckboxInput, {
                                                                id: option.value,
                                                                value: Boolean(selecteds.find(function(item) {
                                                                    return item.value === option.value;
                                                                })),
                                                                onChange: handleChange,
                                                                className: "w-full",
                                                                disabled: disabled,
                                                                title: option.tooltip,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "flex items-center truncate",
                                                                    children: option.label
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, option.value);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }))
    });
});
var MultipleSelectInputV2 = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, // eslint-disable-next-line no-unused-vars
ref) {
    var id = _param.id, label = _param.label, error = _param.error, placeholder = _param.placeholder, disabled = _param.disabled, emptyState = _param.emptyState, _value = _param.value, value = _value === void 0 ? [] : _value, onChange = _param.onChange, options = _param.options, variant = _param.variant, name = _param.name, _actionComponent = _param.actionComponent, actionComponent = _actionComponent === void 0 ? null : _actionComponent, rest = _object_without_properties(_param, [
        "id",
        "label",
        "error",
        "placeholder",
        "disabled",
        "emptyState",
        "value",
        "onChange",
        "options",
        "variant",
        "name",
        "actionComponent"
    ]);
    var ref1 = useState(value), selecteds = ref1[0], setSelecteds = ref1[1];
    useEffect(function() {
        if (value.length !== selecteds.length) {
            setSelecteds(value);
        }
    }, [
        value,
        selecteds
    ]);
    var classes = getSelectClasses({
        error: error,
        disabled: disabled,
        variant: variant
    });
    return /*#__PURE__*/ _jsx(InputController, {
        id: id,
        label: label,
        error: error,
        name: name,
        children: /*#__PURE__*/ _jsx(Listbox, _object_spread_props(_object_spread({
            defaultValue: selecteds,
            disabled: disabled,
            name: name
        }, rest), {
            children: function() {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mt-1 relative",
                        children: [
                            /*#__PURE__*/ _jsxs(Listbox.Button, {
                                className: classes,
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-gray-500",
                                        children: placeholder
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "absolute inset-y-0 right-0 flex items-center pr-2 cursor-default",
                                        children: /*#__PURE__*/ _jsx(ChevronDownIcon, {
                                            className: "h-7 w-7 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            !disabled && actionComponent,
                            /*#__PURE__*/ _jsxs(Listbox.Options, {
                                className: "absolute z-20 mt-1 w-min bg-white shadow-lg max-h-60 rounded-md text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm right-0 overflow-hidden",
                                children: [
                                    emptyState && !options.length && /*#__PURE__*/ _jsx(Listbox.Option, {
                                        disabled: true,
                                        children: function() {
                                            return /*#__PURE__*/ _jsx("div", {
                                                className: "flex flex-1 items-center pl-4 pt-3 pb-3",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    className: classNames("block truncate font-normal"),
                                                    children: emptyState
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "overflow-auto max-h-36",
                                        children: options.map(function(option) {
                                            var handleChange = function() {
                                                if (selecteds.find(function(item) {
                                                    return item.value === option.value;
                                                })) {
                                                    onChange && onChange(selecteds.filter(function(item) {
                                                        return item.value !== option.value;
                                                    }));
                                                    setSelecteds(selecteds.filter(function(item) {
                                                        return item.value !== option.value;
                                                    }));
                                                } else {
                                                    onChange && onChange(_to_consumable_array(selecteds).concat([
                                                        option
                                                    ]));
                                                    setSelecteds(_to_consumable_array(selecteds).concat([
                                                        option
                                                    ]));
                                                }
                                            };
                                            return /*#__PURE__*/ _jsx("div", {
                                                className: classNames("cursor-default select-none relative p-3 text-gray-900 ", !disabled && "hover:bg-indigo-600 hover:text-white", disabled && "opacity-50 hover:bg-white pointer-events-none"),
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "flex flex-1 w-full items-center",
                                                    children: /*#__PURE__*/ _jsx(CheckboxInput, {
                                                        id: option.value,
                                                        value: Boolean(selecteds.find(function(item) {
                                                            return item.value === option.value;
                                                        })),
                                                        onChange: handleChange,
                                                        className: "w-full",
                                                        disabled: option.disabled,
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: "flex items-center truncate",
                                                            children: option.label
                                                        })
                                                    })
                                                })
                                            }, option.value);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }))
    });
})));
var CheckboxInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var error = param.error, id = param.id, children = param.children, name = param.name, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, onBlur = param.onBlur, value = param.value, disabled = param.disabled, className = param.className;
    var checkboxClasses = getCheckboxClasses({
        error: error,
        disabled: disabled
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative flex items-start w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)("flex", className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    id: id,
                    name: name,
                    ref: ref,
                    type: "checkbox",
                    className: checkboxClasses,
                    disabled: disabled,
                    onChange: onChange,
                    checked: value,
                    onBlur: onBlur
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: id,
                    className: "flex items-center w-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full",
                        children: children
                    })
                })
            ]
        })
    });
});
var CheckRadioInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var _formId = _param.formId, formId = _formId === void 0 ? "profile" : _formId, error = _param.error, label = _param.label, _options = _param.options, options = _options === void 0 ? [] : _options, value = _param.value, disabled = _param.disabled, _checkboxPosition = _param.checkboxPosition, checkboxPosition = _checkboxPosition === void 0 ? "justify-start" : _checkboxPosition, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "formId",
        "error",
        "label",
        "options",
        "value",
        "disabled",
        "checkboxPosition"
    ]);
    var ref1 = getRadioClasses({
        error: error,
        disabled: disabled
    }), checkboxClasses = ref1.checkboxClasses, iconClasses = ref1.iconClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center text-sm leading-5 font-medium text-gray-700",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                role: "radiogroup",
                className: "flex ".concat(checkboxPosition, " items-center gap-4 mt-3"),
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex relative items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                                id: "".concat(formId, "-").concat(option, "-").concat(index),
                                ref: ref,
                                type: "radio",
                                value: option,
                                className: checkboxClasses,
                                disabled: disabled,
                                tabIndex: 0
                            })),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                htmlFor: "".concat(formId, "-").concat(option, "-").concat(index),
                                className: "flex items-center font-medium text-gray-700 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        role: "radio",
                                        "aria-checked": value === option,
                                        style: {
                                            minWidth: "1rem",
                                            minHeight: "1rem"
                                        },
                                        className: iconClasses(value === option),
                                        children: value === option && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            width: "10",
                                            height: "8",
                                            viewBox: "0 0 10 8",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M9.20643 0.792787C9.3939 0.980314 9.49922 1.23462 9.49922 1.49979C9.49922 1.76495 9.3939 2.01926 9.20643 2.20679L4.20643 7.20679C4.0189 7.39426 3.76459 7.49957 3.49943 7.49957C3.23427 7.49957 2.97996 7.39426 2.79243 7.20679L0.792431 5.20679C0.610272 5.01818 0.509478 4.76558 0.511757 4.50339C0.514035 4.24119 0.619204 3.99038 0.804612 3.80497C0.99002 3.61956 1.24083 3.51439 1.50303 3.51211C1.76523 3.50983 2.01783 3.61063 2.20643 3.79279L3.49943 5.08579L7.79243 0.792787C7.97996 0.605316 8.23427 0.5 8.49943 0.5C8.7646 0.5 9.0189 0.605316 9.20643 0.792787Z",
                                                fill: "white"
                                            })
                                        })
                                    }),
                                    option
                                ]
                            })
                        ]
                    }, "".concat(formId, "-").concat(option, "-").concat(index));
                })
            })
        ]
    });
});
var TextInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var error = _param.error, id = _param.id, label = _param.label, className = _param.className, disabled = _param.disabled, name = _param.name, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "error",
        "id",
        "label",
        "className",
        "disabled",
        "name"
    ]);
    var classes = getInputClasses({
        error: error,
        disabled: disabled
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputController, {
        id: id,
        label: label,
        error: error,
        name: name,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            ref: ref,
            id: id,
            name: name,
            className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(classes, className),
            disabled: disabled
        }, props))
    });
});
var TextArea = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var error = _param.error, id = _param.id, label = _param.label, className = _param.className, disabled = _param.disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "error",
        "id",
        "label",
        "className",
        "disabled"
    ]);
    var classes = getInputClasses({
        error: error,
        disabled: disabled
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputController, {
        id: id,
        label: label,
        error: error,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            ref: ref,
            id: id,
            className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(classes, className),
            disabled: disabled
        }, props))
    });
});
var PasswordInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var error = _param.error, label = _param.label, id = _param.id, disabled = _param.disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "error",
        "label",
        "id",
        "disabled"
    ]);
    var classes = getInputClasses({
        error: error,
        disabled: disabled
    });
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = _$ref[0], setShowPassword = _$ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputController, {
        id: id,
        label: label,
        error: error,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    id: id,
                    ref: ref,
                    className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(classes, "pr-10"),
                    type: !show ? "password" : "text",
                    autoComplete: "current-password",
                    disabled: disabled
                }, props)),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute inset-y-0 right-0 flex items-center space-x-2 pr-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "h-5 cursor-pointer",
                        onClick: function() {
                            return setShowPassword(function(curr) {
                                return !curr;
                            });
                        },
                        children: [
                            !show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                className: "h-5 w-5 text-gray-300"
                            }),
                            show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                className: "h-5 w-5 text-gray-300"
                            })
                        ]
                    })
                })
            ]
        })
    });
});
var UploadFileButton = function(param) {
    var children = param.children, onChange = param.onChange, disabled = param.disabled, loading = param.loading, _accept = param.accept, accept = _accept === void 0 ? "application/pdf" : _accept;
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: inputRef,
                type: "file",
                name: "file",
                id: "file",
                accept: accept,
                className: "hidden",
                onClick: function(e) {
                    return e.target.value = null;
                },
                onChange: function(e) {
                    return onChange && onChange(e.target.files[0]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                onClick: function() {
                    var ref;
                    return inputRef === null || inputRef === void 0 ? void 0 : (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.click();
                },
                disabled: disabled,
                loading: loading,
                children: children
            })
        ]
    });
};
var Label = function(param) {
    var inputId = param.inputId, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        id: "label-".concat(inputId),
        htmlFor: inputId,
        className: "block text-sm font-medium leading-5 text-gray-700",
        children: children
    });
};
var InputController = function(param) {
    var id = param.id, label = param.label, error = param.error, children = param.children, inputName = param.name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                inputId: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-1 relative",
                children: children
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "mt-1 text-sm text-red-500",
                children: [
                    error.message && error.message,
                    !error.message && getErrorMessage(error, inputName)
                ]
            })
        ]
    });
};
var DateInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var error = _param.error, id = _param.id, label = _param.label, className = _param.className, disabled = _param.disabled, value = _param.value, onChange = _param.onChange, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "error",
        "id",
        "label",
        "className",
        "disabled",
        "value",
        "onChange"
    ]);
    var classes = getInputClasses({
        error: error,
        disabled: disabled
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputController, {
        id: id,
        label: label,
        error: error,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_imask__WEBPACK_IMPORTED_MODULE_2__/* .IMaskInput */ .oc, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            className: (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(classes, className),
            mask: Date,
            inputRef: ref,
            onAccept: function(value) {
                return onChange(value);
            },
            defaultValue: value
        }, props))
    });
});
var getErrorMessage = function(error, inputName) {
    var type = error.type;
    if (Array.isArray(error)) {
        var ref;
        type = (ref = error.find(function(e) {
            var ref;
            return (e === null || e === void 0 ? void 0 : (ref = e.ref) === null || ref === void 0 ? void 0 : ref.name) === inputName;
        })) === null || ref === void 0 ? void 0 : ref.type;
        if (!type) return "";
    }
    if (type === "required" || type === "min") {
        return wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_4__/* ["default"].required_field.message */ .Z.required_field.message;
    }
    if (type === "internal") {
        return error[inputName];
    }
    console.log("Unmapped field error", "Type:".concat(type));
    return "";
};
var getInputClasses = function(param) {
    var error = param.error, disabled = param.disabled;
    return (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(error && "border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500 focus:ring-1", !error && "focus:ring-indigo-500 focus:border-indigo-500 border-gray-300", "border leading-5 shadow-sm block w-full rounded-md px-3 py-2 text-sm bg-white", disabled && "cursor-default opacity-50 bg-gray-100");
};
var getSelectClasses = function(param) {
    var error = param.error, disabled = param.disabled, variant = param.variant;
    return (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(error && "border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500", !error && "focus:ring-indigo-500 focus:border-indigo-500 border-gray-300", "leading-5 block w-full", "bg-white relative w-full py-2 text-left cursor-default focus:outline-none text-sm", variant !== "invisible" && "pl-3 pr-10 border shadow-sm rounded-md focus:ring-1", disabled && variant !== "invisible" && "cursor-default opacity-50 bg-gray-100", disabled && variant === "invisible" && "cursor-default opacity-50");
};
var getCheckboxClasses = function(param) {
    var error = param.error, disabled = param.disabled;
    return (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(error && "bg-red-100 border border-red-300", disabled && "cursor-default opacity-50", !error && "border border-gray-300", "focus:ring-indigo-500 h-4 w-4 text-indigo-600 rounded mr-3");
};
var getRadioClasses = function(param) {
    var error = param.error, disabled = param.disabled;
    var checkboxClasses = (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(error && "bg-red-100", disabled && "cursor-default opacity-50 bg-gray-300", "h-4 w-4 text-white rounded mr-3");
    var iconClasses = function(checked) {
        return (0,lib_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(error && "border border-red-300", disabled && "cursor-default opacity-70", checked && "bg-indigo-600 border border-indigo-600", !checked && !error && "bg-white border border-gray-300", "focus:ring-indigo-500 h-4 w-4 rounded absolute top-0.5 left-0 flex items-center justify-center");
    };
    return {
        checkboxClasses: checkboxClasses,
        iconClasses: iconClasses
    };
};


/***/ }),

/***/ 17481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* provided dependency */ var process = __webpack_require__(34155);

var errorsMessages = {
    required_field: {
        message: "This field is required."
    },
    number_type: {
        message: "This field must be a number."
    },
    checked_field: {
        message: "This field must be checked."
    },
    confirmation_password: {
        message: "Confirmation does not match password."
    },
    invalid_pl_email: {
        message: "Protocol Labs users must sign up with Google."
    },
    email_must_be_valid: {
        message: "Email must be a valid email."
    },
    password_min_length: {
        length: 8,
        message: "This field must be at least 8 characters."
    },
    positive_number: {
        message: "This field must be positive."
    },
    not_found: {
        message: "Not found."
    },
    email_in_use: {
        message: "Email already being used."
    },
    wallet_address_in_use: {
        message: "Address already being used."
    },
    wrong_credentials: {
        message: "Wrong credentials."
    },
    invalid_token: {
        message: "Invalid token."
    },
    something_went_wrong: {
        message: "Something went wrong, please try again later."
    },
    account_not_found_or_already_verified: {
        message: "Account not found or is already verified."
    },
    email_is_not_verified: {
        message: "Email is not verified."
    },
    daily_verification_limit: {
        message: "Reached maximum number of daily verifications."
    },
    wallet_address_already_verified: {
        message: "Wallet address already verified."
    },
    error_approving_transfer_request: {
        message: "Error approving transfer request."
    },
    error_rejecting_transfer_request: {
        message: "Error rejecting transfer request."
    },
    error_deleting_transfer_request: {
        message: "Error deleting transfer request."
    },
    error_voiding_transfer_request: {
        message: "Error voiding transfer request."
    },
    error_unblocking_transfer_request: {
        message: "Error unblocking transfer request."
    },
    error_blocking_transfer_request: {
        message: "Error blocking transfer request."
    },
    error_rejecting_blocked_transfer_request: {
        message: "Error rejecting blocked transfer request."
    },
    error_blocking_user: {
        message: "Error blocking user."
    },
    error_unblocking_user: {
        message: "Error unblocking user."
    },
    error_approving_tax_form: {
        message: "Error approving tax form."
    },
    error_rejecting_tax_form: {
        message: "Error rejecting tax form."
    },
    transfer_request_not_found: {
        message: "Error transfer request not found."
    },
    error_archiving_program: {
        message: "Error archiving program."
    },
    error_status_is_not_supported: {
        message: "Status is not supported."
    },
    wallet_not_found: {
        message: "This wallet address does not exist"
    },
    wallet_incorrect: {
        message: "This wallet address appears to be incorrect."
    },
    error_creating_draft: {
        message: "Error creating transfer request draft"
    },
    program_not_found: {
        message: "Program not found"
    },
    user_already_invited: {
        message: "This user has already been invited."
    },
    default_wallet_not_found: {
        message: "Default Wallet not found, please specify a wallet."
    },
    f410_wallet_error: {
        message: "f410 wallets are not supported yet"
    },
    file_has_active_transfer_request: {
        message: function(ids) {
            return "This file is used by transfer requests ".concat(ids.map(function(id) {
                return '<a style="text-decoration: underline;color: rgba(3, 105, 161, 1);" href="'.concat(process.env.APP_URL, "/transfer-requests/").concat(id, '" target="_blank">#').concat(id, "</a>");
            }).join(", "), ". Please change the file of those requests before deleting.");
        }
    },
    wallet_has_active_transfer_request: {
        message: function(ids) {
            return "Wallet is used by transfer requests ".concat(ids.map(function(id) {
                return '<a style="text-decoration: underline;color: rgba(3, 105, 161, 1);" href="'.concat(process.env.APP_URL, "/transfer-requests/").concat(id, '" target="_blank">#').concat(id, "</a>");
            }).join(", "), ". Please change the wallet addresses of those requests before deleting the wallet.");
        }
    },
    user_without_default_wallet: {
        message: "User without default wallet"
    },
    program_vesting_not_supported: {
        message: "Program doesn't support vesting."
    },
    different_start_epoch: {
        message: "All selected transfer requests need to have the same Vesting Start Epoch."
    },
    invalid_vesting_months_range: {
        message: "Vesting month range has to be between 0 and 200."
    },
    expired_token_link: {
        message: "The link has expired, please try again."
    },
    auth_code_not_found: {
        message: "Verification code not found."
    },
    auth_code_expired: {
        message: "Verification code expired, please request a new one."
    },
    invalid_wallet_program_ethereum: {
        message: "f4 / 0x addresses can't be used as receiving address if the delivery method is multisig"
    },
    invalid_wallet_program_ethereum_address: {
        message: function(address) {
            return "f4 / 0x addresses (".concat(address, ") can't be used as receiving address if the delivery method is multisig");
        }
    },
    invalid_default_wallet_ethereum: {
        message: "f4 / 0x addresses can't be set as a default address"
    },
    wallet_verification_not_found: {
        message: "Verification not found."
    },
    wallet_verification_value_not_match: {
        message: "Amount provided did not match amount sent."
    },
    wallet_verification_not_found_on_chain: {
        message: " We have not received your transaction. It may take up to 5 minutes for the transaction to go through. Try verifying again in a few minutes."
    },
    currency_not_found: {
        message: "Currency was not found."
    },
    wallet_cant_be_empty: {
        message: "Please, provide a wallet address."
    },
    auth_code_cant_generate: {
        message: "A new code can't be generated now, please try again in 1 minute."
    },
    user_not_found: {
        message: "User not found."
    },
    applying_for_others_unchek: {
        message: "To create a transfer request for yourself, go to My Requests page."
    },
    user_rejected_payment: {
        message: "Payment rejected by the user",
        component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            children: "Payment rejected by the user"
        })
    },
    not_enough_funds: {
        message: "Sorry, you do not have enough funds in your account to complete the transaction. Please ensure you have sufficient balance and try again.",
        component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            children: "Sorry, you do not have enough funds in your account to complete the transaction. Please ensure you have sufficient balance and try again."
        })
    },
    check_account_balance: {
        message: "Please check your account balance to ensure you have enough funds for the transaction.",
        component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            children: "Please check your account balance to ensure you have enough funds for the transaction."
        })
    },
    error_during_payment: {
        message: "An error occurred during payment. Please try again, if the problem persists contact support on emissary@protocol.ai.",
        component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            children: [
                "An error occurred during payment. Please try again, if the problem persists contact support on",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "text-purple-500",
                    href: "mailto:emissary@protocol.ai",
                    children: "emissary@protocol.ai"
                }),
                "."
            ]
        })
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (errorsMessages);


/***/ })

}]);